/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_ReadCoilStatus',
        template: `
function modbus_callback_ReadCoilStatus(address as word) as boolean
modbus_callback_ReadCoilStatus=false
select case address
'****modbus_callback_ReadCoilStatus****'
case else:
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_ReadInputStatus',
        template: `
function modbus_callback_ReadInputStatus(address as word) as boolean
modbus_callback_ReadInputStatus=false
select case address
'****modbus_callback_ReadInputStatus****'
case else:
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_WriteSingleCoil',
        template: `
function modbus_callback_WriteSingleCoil(address as word, value as low_high) as byte
modbus_callback_WriteSingleCoil=0
select case address
'****modbus_callback_WriteSingleCoil****'
case else
modbus_callback_WriteSingleCoil=2
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_ReadHoldingRegister',
        template: `
function modbus_callback_ReadHoldingRegister(address as word) as word
modbus_callback_ReadHoldingRegister=0
select case address
'****modbus_callback_ReadHoldingRegister****'
case else:
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_ReadInputRegister',
        template: `
function modbus_callback_ReadInputRegister(address as word) as word
modbus_callback_ReadInputRegister=0
select case address
'****modbus_callback_ReadInputRegister****'
case else:
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'modbus_callback_set_holding_register',
        template: `
function modbus_callback_set_holding_register(address as word, data as word) as boolean
modbus_callback_set_holding_register = true
dim short_data as short
select case address
'****modbus_callback_set_holding_register****'
case else
modbus_callback_set_holding_register = false
end select
end function
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_modbus_slave_reply',
        template: `
sub callback_modbus_slave_reply(byref request_item as modbus_request_item, byref reply as string)
dim bytes as byte(255) = reply
dim short_data as short
dim data as float = 0
dim device_id as word=request_item.device_id
dim register_address as word=request_item.start_register
dim response_data as word=0
select case request_item.request_function
    case ReadCoilStatus,ReadInputStatus,WriteSingleCoil,WriteMultipleCoils:
        response_data=bytes(0) AND 1
    case ReadHoldingRegisters,ReadInputRegisters,PresetSingleRegister,PresetMultipleRegisters:
        response_data=(bytes(0) SHL 8) OR bytes(1)

end select


'****callback_modbus_slave_reply****'
end sub`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_modbus_slave_reply_timeout',
        template: `
sub callback_modbus_slave_reply_timeout(byref request_item as modbus_request_item)
dim device_id as word=request_item.device_id
dim register_address as word=request_item.start_register
'****callback_modbus_slave_reply_timeout****'
end sub`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
    'Modbus Setup
    '==================================
    modbus_initialize()
    '****modbus_setup****'
    '----------------------------------`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: 'modbus_create_data',
        template: `
function modbus_create_data(func_type as modbusFunc, data as string) as string
    modbus_create_data=""
    select case func_type
        case WriteSingleCoil
            dim tmp_value as byte=val(data)
            if tmp_value=1 then
                modbus_create_data=chr(&hFF) + chr(&h00)
            else 
                modbus_create_data=chr(&h00) + chr(&h00)
            end if
        case PresetSingleRegister
            dim tmp_value as word=val(data)
            if tmp_value < 0 then
                tmp_value=tmp_value+65536
            end if
            modbus_create_data=chr(tmp_value SHR 8)+chr(tmp_value AND &hFF)
            
    end select
end function`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare function modbus_create_data(func_type as modbusFunc, data as string) as string`,
    });

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
    modbus_proc_timer()`,
    });

    return blocks;
};
